import React from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
  DropdownItem,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import { selectColor } from '../../function'
import { FONTS, COLORS } from '../../constants'

class ModalLeaveDetial extends React.PureComponent {
  render() {
    const events = get(this.props, 'events', [])

    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'showDetail') }
        toggle={ get(this.props, 'handleLeaveDetail') }
      >
        <ModalHeader toggle={ get(this.props, 'handleLeaveDetail') }>
          <Header>
            { get(this.props, 'flag') === 0 ? 'Leave Request' : 'Holiday' }
          </Header>
        </ModalHeader>
        {
          get(this.props, 'flag') === 0 &&
            <ModalBody style={ { overflowY: 'auto', height: '500px' } }>
              <LabelText>Leave Type</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'leave_type') }</TextInfo>
                </Col>
              </Row>
              <LabelText>Leave Date</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>
                    { `${moment(get(events[0], 'start_date')).format('DD/MM/YYYY')} - ${moment(get(events[0], 'end_date')).format('DD/MM/YYYY')}` }
                  </TextInfo>
                </Col>
              </Row>
              <LabelText>Leave Time</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'leave_time') }</TextInfo>
                </Col>
              </Row>
              <LabelText>Total Leave Day</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'days') } days</TextInfo>
                </Col>
              </Row>
              <LabelText>Approver</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'approver') }</TextInfo>
                </Col>
              </Row>
              {
                get(events[0], 'attachment_url') !== '' &&
                <div>
                  <LabelText>Attachments</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>
                        <CustomButton
                          color="info"
                          onClick={ () => window.open(get(events[0], 'attachment_url'), 'blank') }
                        >Download</CustomButton>
                      </TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'status') !== '' &&
                <div>
                  <LabelText>Status</LabelText>
                  <Row noGutters>
                    <Col>
                      <span
                        style={ {
                          color: selectColor(get(events[0], 'status')),
                          fontWeight: 'bold',
                        } }
                      >
                        <TextInfo>{ get(events[0], 'status') }</TextInfo>
                      </span>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_request_user') !== '' &&
                <div>
                  <LabelText>Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_request_user') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_approver') !== '' &&
                <div>
                  <LabelText>Approver Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_approver') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_hr') !== '' &&
                <div>
                  <LabelText>HR Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_hr') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_cancel') !== '' &&
                <div>
                  <LabelText>Cancel Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_cancel') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events, 'length') > 1 &&
                <div>
                  <DropdownItem divider />
                  <LabelText>Leave Type</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'leave_type') }</TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Leave Date</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>
                        { moment(get(events[1], 'start_date')).format('DD/MM/YYYY') } - { moment(get(events[1], 'end_date')).format('DD/MM/YYYY') }
                      </TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Leave Time</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'leave_time') }</TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Total Leave Day</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'days') } days</TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Approver</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'approver') }</TextInfo>
                    </Col>
                  </Row>
                  {
                    get(events[1], 'attachment_url') !== '' &&
                    <div>
                      <LabelText>Attachments</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>
                            <CustomButton
                              color="info"
                              onClick={ () => window.open(get(events[1], 'attachment_url'), 'blank') }
                            >
                            Download
                            </CustomButton>
                          </TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'status') !== '' &&
                    <div>
                      <LabelText>Status</LabelText>
                      <Row noGutters>
                        <Col>
                          <span
                            style={ {
                              color: selectColor(get(events[1], 'status')),
                              fontWeight: 'bold',
                            } }
                          >
                            <TextInfo>{ get(events[1], 'status') }</TextInfo>
                          </span>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_request_user') !== '' &&
                    <div>
                      <LabelText>Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_request_user') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_approver') !== '' &&
                    <div>
                      <LabelText>Approver Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_approver') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_hr') !== '' &&
                    <div>
                      <LabelText>HR Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_hr') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_cancel') !== '' &&
                    <div>
                      <LabelText>Cancel Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_cancel') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                </div>
              }
            </ModalBody>
        }
        {
          get(this.props, 'flag') === 1 &&
            <ModalBody>
              <TextInfo>{ get(this.props, 'holiday_name') }</TextInfo>
            </ModalBody>
        }
      </Modal>
    )
  }
}

export default ModalLeaveDetial

// const Background = styled.div`
//   background-color: #F1F1F1;
//   padding-left: 10px;
//   font-family: ${FONTS.GOTHAM_MEDIUM} !important;
//   font-size: ${FONTS.NORMAL_SIZE};
// `
const LabelText = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 0px;
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/modal-leave-detail/index.js